export default __webpack_public_path__ + "static/media/icons-user-group-green-32-px.ef255422.svg";